import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { ICompany } from 'app/shared/model/company.model';
import { IKpiPreset } from 'app/shared/model/kpi-preset.model';

export interface IKpiPresetVehicle {
  id?: number;
  activated?: boolean | null;
  truckImplement?: ITruckImplement | null;
  kpiPreset?: IKpiPreset | null;
}

export const defaultValue: Readonly<IKpiPresetVehicle> = {
  activated: false,
};
